// src/components/DepartmentRow.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DEPARTMENTS, DEPARTMENT_OTHER } from '../constants/departments';
import './DepartmentRow.css';

export default function DepartmentRow() {
  const navigate = useNavigate();
  const items = [...DEPARTMENTS, DEPARTMENT_OTHER];

  return (
    <section className="dept-wrapper" aria-label="Shop by department">


<div className="dept-titlebar">
   <h3 className="dept-title">Shop by department</h3>
   <button
     className="dept-viewall"
     onClick={() => navigate('/marketplace/departments')}
     aria-label="View all departments"
   >
     View All
   </button>
 </div>

      <div className="dept-scroll" role="listbox" aria-label="Departments">
        {items.map(d => (
          <button
            key={d.key}
            role="option"
            className="dept-pill"
            onClick={() => navigate(`/marketplace/department/${d.key}`)}
            title={d.label}
          >
            <span className="dept-emoji" aria-hidden>{d.emoji}</span>
            <span className="dept-label">{d.label}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
